import React from "react";

const ContactLoader = props => {
  const { count = 10, contactFields = [] } = props;
  return (
    <>
      {Array.from({ length: count }, (value, index) => (
        <tr
          className="ctTableBody ctTableBodyLoader"
          key={`ctTableBodyLoader${index}`}
        >
          <td className="ctSelectAll">
            <div>
              <span className="linear-background"></span>
            </div>
          </td>
          {contactFields
            .filter(field => field.enabled)
            .map((field, idx) => {
              // Split name/email and job/company as in the current loader
              if (field.key === "name") {
                return (
                  <td className="nameWrapper" key={field.key}>
                    <span className="name linear-background"></span>
                  </td>
                );
              }
              if (field.key === "email") {
                return (
                  <td key={field.key}>
                    <span className="email linear-background"></span>
                  </td>
                );
              }
              if (field.key === "jobTitle") {
                return (
                  <td
                    className="companyJobTile"
                    title="Job Title & Company"
                    key={field.key}
                  >
                    <span className="job linear-background"></span>
                  </td>
                );
              }
              if (field.key === "company") {
                return (
                  <td className="companyJobTile" key={field.key}>
                    <span className="company linear-background"></span>
                  </td>
                );
              }
              // Use existing loader for tags
              if (field.key === "contactTags") {
                return (
                  <td className="tag" key={field.key}>
                    <span className="tagNameTable linear-background"></span>
                    <span className="moreTags linear-background"></span>
                  </td>
                );
              }
              // Use existing loader for stage/status
              if (field.key === "stageDisplayName") {
                return (
                  <td className="status" key={field.key}>
                    <span className="text linear-background"></span>
                  </td>
                );
              }
              // Use existing loader for insights
              if (field.key === "insights") {
                return (
                  <td className="stageInsight insight-loader" key={field.key}>
                    {Array.from({ length: 4 }, (value, i) => (
                      <div
                        key={`ctTableBodyInsightLoader${i}`}
                        className="linear-background"
                      ></div>
                    ))}
                  </td>
                );
              }
              // Use existing loader for lastContacted
              if (field.key === "lastContacted") {
                return (
                  <td className="lastContacted" key={field.key}>
                    <span className="linear-background"></span>
                  </td>
                );
              }
              // Use existing loader for owner
              if (field.key === "owner") {
                return (
                  <td className="ctOwner" key={field.key}>
                    <span className="linear-background"></span>
                  </td>
                );
              }
              // Use existing loader for actions
              if (field.key === "action" || field.key === "actions") {
                return (
                  <td className="actionDp" key={field.key}>
                    <div>
                      <span className="linear-background"></span>
                    </div>
                  </td>
                );
              }
              // Generic loader for all other fields
              return (
                <td key={field.key} className={field.loaderClassName || ""}>
                  <span className="linear-background"></span>
                </td>
              );
            })}
        </tr>
      ))}
    </>
  );
};

export default ContactLoader;
export { ContactLoader };
